import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ViewMore from '../../components/ViewMore';

const PagesToLife = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '25px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-track {
                display:flex;
                margin:0
              }
            .slick-slide{
                width:33%;
                margin-right:5px
            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4; 
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
                    .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important;
                            }
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-white px-18 py-12  min-h-340 md:min-h-280'}>
            <img src="https://weprodigi.com/uploads/images/custom-landings/ab2.png" className={'w-full mb-20'} alt="ab2" />
            <h3 className={'font-bold text-24 leading-29 text-black uppercase'}>The power of A/B Testing</h3>
            <div className={'pr-0 md:pr-30'}>
              <ViewMore ln={15}>
                We understand the importance of A/B testing and its potential to drive significant improvements in conversion rates. Our team of
                experts uses a data-driven approach to conduct thorough A/B tests on various elements of your landing pages, including headers,
                images, copy, and call-to-action buttons. This helps us identify the most effective combinations and ultimately improve the overall
                user experience for your company.
              </ViewMore>
            </div>
          </div>
        </div>
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-white px-18 py-12  min-h-340 md:min-h-280'}>
            <img src="https://weprodigi.com/uploads/images/custom-landings/no_template2.png" className={'w-full mb-20'} alt="no_template2" />
            <h3 className={'font-bold text-24 leading-29 text-black uppercase'}>Unique Solutions, Not Templates</h3>
            <div className={'pr-0 md:pr-30'}>
              <ViewMore ln={15}>
                We understand the importance of A/B testing and its potential to drive significant improvements in conversion rates. Our team of
                experts uses a data-driven approach to conduct thorough A/B tests on various elements of your landing pages, including headers,
                images, copy, and call-to-action buttons. This helps us identify the most effective combinations and ultimately improve the overall
                user experience for your company.
              </ViewMore>
            </div>
          </div>
        </div>
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-white px-18 py-12  min-h-340 md:min-h-280'}>
            <img src="https://weprodigi.com/uploads/images/custom-landings/landing1.png" className={'w-full mb-20'} alt="landing1" />
            <h3 className={'font-bold text-24 leading-29 text-black uppercase'}>Landing Pages with Magic Conversions</h3>
            <div className={'pr-0 md:pr-30'}>
              <ViewMore ln={15}>
                We understand the importance of A/B testing and its potential to drive significant improvements in conversion rates. Our team of
                experts uses a data-driven approach to conduct thorough A/B tests on various elements of your landing pages, including headers,
                images, copy, and call-to-action buttons. This helps us identify the most effective combinations and ultimately improve the overall
                user experience for your company.
              </ViewMore>
            </div>
          </div>
        </div>
      </Slider>
    </>
  );
};
export default PagesToLife;
